/**
 * Filo Pinia state + getters (micro-6S-13).
 * Vuex kaynak: `store/modules/vehicleAssignment.js`
 */
export function createFleetState() {
    return {
        vehicles: [],
        assignments: [],
        parkurSureleri: {
            gidis: {},
            donus: {},
        },
        originalParkurSureleri: null,
    };
}
/** Vuex kaynak: vehicleAssignment.js getters — micro-6-2 */
export const fleetGetters = {
    getVehicleAssignments: (state) => (vehicleId) => state.assignments.filter((a) => a.arac_id === vehicleId),
    getTotalVehicles: (state) => state.vehicles.length,
};
